import React, { useState, useEffect } from "react";
import "./carousel.scss";
import { ArrowLeftRounded, ArrowRightRounded } from "@mui/icons-material";

export const Carousel = ({ data, getSlideItem }) => {
  const [slide, setSlide] = useState(0);

  const nextSlide = () => {
    setSlide((prevSlide) => (prevSlide === data.length - 1 ? 0 : prevSlide + 1));
  };

  const prevSlide = () => {
    setSlide((prevSlide) => (prevSlide === 0 ? data.length - 1 : prevSlide - 1));
  };

  useEffect(() => {
    getSlideItem(slide);
  }, [slide, getSlideItem]);

  return (
    <div className="carousel">
      <ArrowLeftRounded onClick={prevSlide} className="arrow arrow-left" />
      {data.map((item, idx) => (
        <img
          src={item.imageUrl}
          key={idx}
          className={`slide ${slide === idx ? '' : 'slide-hidden'}`}
        />
      ))}
      <ArrowRightRounded onClick={nextSlide} className="arrow arrow-right" />
      <span className="indicators">
        {data.map((_, idx) => (
          <button
            key={idx}
            className={`indicator ${slide === idx ? '' : 'indicator-inactive'}`}
            onClick={() => setSlide(idx)}
          />
        ))}
      </span>
    </div>
  );
};

